module.exports = __webpack_public_path__ + "img/9791191689013.ba060d0b.jpg";